<div class="modal-header">
  <h5 class="modal-title">{{ 'WEEKLY_SCHEDULE.TITLE' | translate }}</h5>
  <button 
  type="button" 
  class="btn-close" 
  ngbTooltip="{{ 'COMMON.CLOSE_TOOLTIP' | translate }}" 
  placement="top" 
  triggers="hover" 
  (click)="closeModal()">
</button>


</div>
<div class="modal-body">
  <table class="table table-bordered table-striped align-middle fs-6 gy-4 my-0 pb-3">
      <thead>
          <tr>
              <th>{{ 'WEEKLY_SCHEDULE.DAY' | translate }}</th>
              <th>{{ 'WEEKLY_SCHEDULE.START_TIME' | translate }}</th>
              <th>{{ 'WEEKLY_SCHEDULE.END_TIME' | translate }}</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let row of tableData">
              <td>
                  <div class="position-relative ps-6 pe-3 py-2">
                      <div
                          class="position-absolute start-0 top-0 w-4px h-100 rounded-2"
                          [ngClass]="{
                              'bg-success': row.start && row.end,
                              'bg-danger': !row.start || !row.end
                          }"
                      ></div>
                      <span class="text-gray-900 fw-bold">{{ row.day }}</span>
                  </div>
              </td>
              <td>
                  <span *ngIf="row.start; else inactive">{{ row.start | timezoneDate:'HH:mm' }}</span>
                  <ng-template #inactive>
                      <span class="text-muted">{{ 'WEEKLY_SCHEDULE.NOT_ACTIVE' | translate }}</span>
                  </ng-template>
              </td>
              <td>
                  <span *ngIf="row.end; else inactiveEnd">{{ row.end | timezoneDate:'HH:mm' }}</span>
                  <ng-template #inactiveEnd>
                      <span class="text-muted">{{ 'WEEKLY_SCHEDULE.NOT_ACTIVE' | translate }}</span>
                  </ng-template>
              </td>
          </tr>
      </tbody>
  </table>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">
      {{ 'COMMON.CLOSE' | translate }}
  </button>
</div>
